import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <div className="about" id="about" ref={this.props.refName}>
        <div className="section-heading">
          <h1>About</h1>
          <div className="shadow">About</div>
        </div>

        <div className="design-background-1" />

        <div className="about-text">
          <p>
            Dalí, Cauchy, and Bandit are the "Chaos Chinchillas", 3 fluffy
            companions that enjoy their rodent lifestyle together.  
            
            All born in
            2016 they spent their entire lives together. Due to their undeniable
            cuteness over the years a lot of picture and video content was
            shared on social media.
          </p>
          <p>
            This web space serves as an additional resource to share fun content
            surrounding the floof balls. Check out the personality type quiz or get yourself the adorable Chaos Chinchillas sticker pack for Telegram!
          </p>
        </div>
        <div className="design-background-2">
          <div className="dots horizontal">
            {/* <div className="dot" />
            <div className="dot" />
            <div className="dot" /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default About;
